import { chatIdMutation } from "@/shared/api/queries"

import { apiSlice } from "@/shared/api"

import type { UploadGroupCustomImageRequest, UploadGroupCustomImageResponse } from "./types"

export const uploadGroupCustomImageApi = apiSlice
  .enhanceEndpoints({
    addTagTypes: ["GroupSettings", "UserCardStyle", "CardStyles", "Balance", "DistributionChats"]
  })
  .injectEndpoints({
    endpoints: builder => ({
      uploadGroupCustomImage: builder.mutation<UploadGroupCustomImageResponse, UploadGroupCustomImageRequest>({
        queryFn: chatIdMutation<UploadGroupCustomImageRequest, UploadGroupCustomImageResponse>((chatId, arg) => {
          const formData = new FormData()
          formData.append("file", arg.file)
          return {
            url: `/api/v1/groups/${chatId}/custom-card-image`,
            method: "PUT",
            body: formData
          }
        }),
        invalidatesTags: (_result, error, { chatId }) =>
          error
            ? []
            : [
                { type: "GroupSettings" as const, id: `CHAT_${chatId}` },
                "UserCardStyle",
                "CardStyles",
                "Balance",
                "DistributionChats"
              ]
      })
    })
  })

export const { useUploadGroupCustomImageMutation } = uploadGroupCustomImageApi
